import { useEffect } from 'react';

import counterpartyAccountByIdentityManager from '@gasbi/shared/common/utils/counterpartyAccountByIdentityManager';
import { useAuth as useOIDCAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';

import { useGetCounterpartyAccountByIdentityIdQuery } from '@/features/counterpartyAccounts/counterpartyAccountsApi';
import { CounterpartyAccountByIdentityId } from '@/features/counterpartyAccounts/types';
import Pages from '@/pages';

import Loader from '@components/Loader';

const AuthCallback = () => {
  const auth = useOIDCAuth();

  let returnTo = (auth.user.state || '/') as string;

  const { data, isLoading, error } = useGetCounterpartyAccountByIdentityIdQuery(
    (auth as any)?.user?.profile?.sub,
    { skip: !auth?.user?.profile?.sub },
  );

  useEffect(() => {
    if (data && !counterpartyAccountByIdentityManager.getState())
      counterpartyAccountByIdentityManager.setState(
        data as CounterpartyAccountByIdentityId,
      );
  }, [data]);

  if (isLoading) {
    return <Loader />;
  }
  if ((error as any)?.status === 401) {
    return <Navigate to={Pages.NOT_AUTHORIZED} replace />;
  }

  if (returnTo === Pages.AUTH_CALLBACK) {
    returnTo = `/`;
  }

  return <Navigate to={returnTo} replace />;
};

export default AuthCallback;
